import { parseISO } from 'date-fns'
import { format, utcToZonedTime } from 'date-fns-tz'

// The browser sees time in local TZ natively. Our UTC times are misinterpreted
//    by default. This addition fixes it.
// https://stackoverflow.com/a/61469549/1170370
export function parseAndApplyOffset (stringValue) {
  // comes in as raw UTC, but browser will interpret as local
  let t = parseISO(stringValue)
  // adjusts back to UTC for the browser
  // this is confusing (you'd expect to use zonedToUtcTime), but it seems to be correct where zonedToUtcTime is not.
  t = utcToZonedTime(t, 'UTC')

  return t
}

// Takes a date string in UTC and outputs a new string with just the date (no time),
//   which may or may not be adjusted to the browser-local timezone
// Parameters:
//   stringValue: required; the datestring to parse
//   toLocalTZ:   optional, boolean, defaults to false. If true, expresses time in browser-local timezone.
//   args: optional map with the following possible keys:
//       showDate: optional, boolean, defaults to true. When true, outputs date as yyyy-MM-dd or MMM d, yyyy - see dateFormat key also
//       showTime: optional, boolean, defaults to true. When true, outputs time as h:mm a
//       dateFormat: optional, string, defaults to null. If set to 'dash', outputs date as `yyyy-MM-dd`, otherwise, `MMM d, yyyy` (default)
// {

//   showDate, showTime, showTZ, dateFormat
// dateFormat selects between "dash" or "text", with dash being numeric, and text having the month name.
export function parseTimeToString (stringValue, toLocalTZ, args) {
  let dateString = ''
  args = args ?? {}
  args = (args === null) ? {} : args
  if (stringValue) {
    const t = parseAndApplyOffset(stringValue, toLocalTZ)
    const showDate = (args.showDate ?? true)
    if (showDate) {
      const dateFormat = (args.dateFormat ?? null)
      dateString += format(t, (dateFormat === 'dash') ? 'yyyy-MM-dd' : 'MMM d, yyyy')
    }
    const showTime = (args.showTime ?? true)
    if (showTime) {
      dateString += format(t, ' h:mm a')
    }
    const showTZ = (args.showTZ ?? false)
    if (showTZ) {
      dateString += ' UTC'
    }
  }
  return dateString.trim()
}

// Takes a date string in UTC and outputs 3 numeric values for month, day, year (no time),
//    which may or may not be adjusted to the browser-local timezone
export function parseTimeToMDY (stringValue) {
  const t = parseAndApplyOffset(stringValue)
  return { month: t.getMonth(), day: t.getDate(), year: t.getFullYear() }
}
